import { ExternalLink, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LEGAL_NAVIGATOR_URL } from '../../../../lib/constants.js';
import { Button } from '../../../ui/button.js';

const OPENAI_PRIVACY_POLICY_URL = 'https://openai.com/policies/privacy-policy/';

/**
 * The Legal Navigator is a ChatGPT app hosted by OpenAI. Loading the iframe sends the viewer's IP address and
 * browser data to OpenAI, so it only loads after an explicit click (two-click solution). The agent may open this
 * canvas on its own; it then only shows the notice. Not persisted: every opening asks again.
 */
export function LegalNavigator() {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);

  if (loaded) {
    return (
      <iframe
        src={LEGAL_NAVIGATOR_URL}
        title={t('Chat.canvasTitles.legal')}
        className="block h-full w-full rounded-lg border border-border"
        referrerPolicy="no-referrer"
      />
    );
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-md space-y-4 rounded-lg border border-border bg-background p-6 text-sm text-foreground">
        <div className="flex items-center gap-2 font-semibold">
          <ShieldAlert className="h-5 w-5 shrink-0" />
          {t('Chat.legalNavigator.title')}
        </div>
        <p>{t('Chat.legalNavigator.notice')}</p>
        <p className="font-medium">{t('Chat.legalNavigator.noStudentData')}</p>
        <a
          href={OPENAI_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 underline"
        >
          {t('Chat.legalNavigator.privacyLink')}
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
        <div>
          <Button onClick={() => setLoaded(true)}>{t('Chat.legalNavigator.load')}</Button>
        </div>
      </div>
    </div>
  );
}
